import React from 'react';

const ButtonFlatAccent = ({ children, size = 'md', ghost = false, onClick = () => {}, disabled = false }) => (
    <button
        className={`appButton__flat appButton__flat--accent${ghost ? ' appButton__flat--accent--ghost' : ''} ${size}`}
        disabled={disabled}
        onClick={onClick}>
        {children}
    </button>
);

export default ButtonFlatAccent;
